import { BalanceBox, getBitcoinFromSats } from "@synota-io/synota-shared-ui";
import { useNodeBalance } from "../../../api/hooks/useNodeBalance";
import { CircularProgress, Stack, Typography } from "@mui/material";
import { IS_ENABLED_REPORTS } from "../../../utils/environment";
import { useAuth } from "../../../api/auth/useAuth";

export const NodeBalance = () => {
  const { isAdmin } = useAuth();
  const { totalAvailable, isPending, error, refetch } = useNodeBalance();

  if (!IS_ENABLED_REPORTS || !isAdmin) {
    return null;
  }

  if (isPending) {
    return (
      <Stack direction="row" gap={4}>
        <CircularProgress size={24} />
      </Stack>
    );
  }

  return (
    <BalanceBox
      alwaysShow={["BTC"]}
      sx={{ px: 4 }}
      onClick={() => refetch()}
      header={
        <Typography variant="caption" fontWeight={600} color="primary.main">
          Fulcrum Balance
        </Typography>
      }
      balances={{ BTC: getBitcoinFromSats(totalAvailable) }}
      slots={error ? { balance: () => "Failed to retrieve" } : {}}
    />
  );
};
